module.exports = __webpack_public_path__ + "static/media/cocina.ea978090.jpg";